(() => {
  if (window.rocketHubMoneyInitialized) return;
  window.rocketHubMoneyInitialized = true;
  function render(root) {
    root.querySelectorAll('[data-hub-money]').forEach(node => {
      const amount = Number(node.dataset.amount);
      const currency = node.dataset.currency;
      const source = node.dataset.sourceCurrency;
      const exchange = window.Shopify?.currency;
      const rate = currency === source ? 1 : exchange?.active === currency ? Number(exchange.rate) : NaN;
      if (!Number.isFinite(amount) || !Number.isFinite(rate) || rate <= 0) return;
      try {
        const formatter = new Intl.NumberFormat(node.dataset.locale || document.documentElement.lang, {
          style: 'currency', currency, currencyDisplay: 'symbol'
        });
        const digits = formatter.resolvedOptions().maximumFractionDigits;
        const factor = 10 ** digits;
        const converted = Math.round(amount * rate * factor) / factor;
        const formatted = new Intl.NumberFormat(node.dataset.locale || document.documentElement.lang, {
          style: 'currency', currency, minimumFractionDigits: Number.isInteger(converted) ? 0 : digits,
          maximumFractionDigits: digits
        }).format(converted);
        node.textContent = node.dataset.template.replaceAll('{amount}', formatted);
      } catch {}
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => render(document), { once: true });
  else render(document);
  document.addEventListener('shopify:section:load', event => render(event.target));
})();
